<template>
  <div class="onboarding-create-site__options-answers-rectangle">
    <label
      ref="answerRectangle"
      class="onboarding-create-site__options-answers-rectangle--item"
      v-for="(option, index) in options"
      :key="index"
    >
      <input
        :id="index"
        class="is-hidden"
        type="checkbox"
        :name="option.text"
        :value="option.value"
        v-model="selectedOptions"
      />
      <BaseCheckbox :checked="isOptionSelected(option.value)" />
      <p>{{ option.text }}</p>
    </label>
  </div>
</template>

<script>
import BaseCheckbox from '@/components/BaseCheckbox.vue'

export default {
  components: {
    BaseCheckbox,
  },

  props: {
    options: Array,
  },

  data() {
    return {
      selectedOptions: [],
    }
  },

  computed: {
    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },

    nextStep: {
      get() {
        return this.$store.state.onboardingCreateSite.nextStep
      },
      set(payload) {
        this.$store.dispatch('setStep', payload)
      },
    },

    currentStep() {
      const currentStep = this.$route.params.id.split('-')
      return `step${currentStep[1]}`
    },
  },

  watch: {
    selectedOptions(newValue) {
      this.answerUser[this.currentStep] = { answer: newValue }

      localStorage.setItem(
        `onboarding_wed${this.answerUser.wed_id}`,
        JSON.stringify({
          ...this.getPreviousAnswer(),
          website_pages: newValue,
        })
      )

      this.nextStep = true
    },
  },

  mounted() {
    const previousAnswer = this.getPreviousAnswer()
    if (previousAnswer?.website_pages) {
      this.selectedOptions = previousAnswer.website_pages
    }
  },

  methods: {
    isOptionSelected(option) {
      return this.selectedOptions.findIndex((item) => item === option) !== -1
    },

    getPreviousAnswer() {
      return JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__options-answers-rectangle {
    max-width: 500px;
    margin: 0 auto;
    padding: 20px 0px 40px;

    &--item {
      margin: 8px 0px;
      border-radius: 8px;
      padding: 10px;
      border: solid 1px $gray-4;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      min-width: 350px;

      p {
        text-align: left;
        padding-left: 5px;
        color: $gray-6;
      }

      &:hover {
        box-shadow: 0 0 16px 0 $gray-4;
      }
    }
  }
}

.has-text-black {
  color: $gray-6 !important;
}
</style>
